<template>
  <v-container>
    <h1>Мои сметы</h1>
    <v-data-table
      :headers="tblHeaders"
      :items="estimates"
      item-key="_id"
      class="elevation-1"
      :loading="loadingEstimates"
      loading-text="Данные загружаются... Пожалуйста, подождите."
      :search="search"
    >
      <template v-slot:top>
        <v-text-field
          v-model="search"
          placeholder="Введите данные для поиска"
          class="pl-4 pr-4"
          clearable
        ></v-text-field>
      </template>
      <template v-slot:[`item.id`]="{item}">
        <router-link :to="{ name: 'SingleEstimate', params: { id: item._id } }">
          {{ item.id }}
        </router-link>
      </template>
      <template v-slot:[`item.datetime`]="{item}">
        {{ item.createdAt | localDatetime }}
      </template>
     
    </v-data-table>
  </v-container>
</template>

<script>
import {mapState, mapGetters} from 'vuex';

export default {
  data() {
    return {
      search: '',
      tblHeaders: [
        {
          text: '№',
          value: 'id'
        },
        {
          text: 'Дата и время',
          value: 'datetime'
        },
        {
          text: 'Адрес',
          value: 'objectEntity.addressPublic'
        },
      ]
    }
  },

  created() {
    document.title = 'Мои сметы';
    this.$store.dispatch('loadEstimates');
  },

  computed: {
    ...mapState(['estimates']),
    ...mapGetters(['loadingEstimates'])
  }
}
</script>